module.exports = __webpack_public_path__ + "img/info.37646e50.svg";